import * as types from "../actions/ActionTypes";
import Helper from "../functions/Helper.js";
import produce from "immer";
import Rollbar from "rollbar";

let rollbarInstance = new Rollbar({
  accessToken: "207b0cae5369443a8c604ffb6bc80e2b",
  payload: {
    environment: "Shoe Reviews Frontend Web",
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: __COMMIT_HASH__,
        guess_uncaught_frames: true,
      },
    },
  },
});

const initialState = {
  visitedQuiz: false,
  filterObject: {},
  overview: [],
  switchValue: 0,
  searchText: "",
  pagination: 1,
  shoesPerPage: 20,
  filterArray: [],
  filterExpanded: {},
  filtering: false,
  showAds: false,
  data: [],
  expanded: [],
  loaded: false,
  experimentVersion: null,
  experimentID: null,
  notifications: [],
  currentShoe: false,
  urlMapping: [],
  secondpage: false,
  abortFunction: () => {},
};

function addExpansion(expandedArray, id) {
  var result = expandedArray.slice();
  result[id] = expandedArray[id] === false;
  return result;
}

function getExpandArray(data) {
  let result = [];
  data.forEach((row) => {
    result[row.shoe_id] = false;
  });
  return result;
}

function setExperimentTracker(variant, id) {
  if (typeof ga === "function") {
    ga("set", "expId", id); // The id of the experiment the user has been exposed to.
    ga("set", "expVar", variant); // The index of the variation shown to the user.
    ga("send", "event", "experiment", "experiment_" + id, variant);
  } else {
    console.log("analytics not loaded");
  }
}

function getExperimentVersion(id) {
  //see routerchanges.jsx for setting of experiment
  let variant = Helper.getCookie("experiment_" + id);
  if (variant !== "") {
    //console.log("read cookie" , Number(variant));
    setExperimentTracker(variant);
    //console.log("set experiment id")
    return Number(variant);
  } else {
    let new_variant = Math.round(Math.random());
    //console.log("set Cookie", new_variant.toString());
    Helper.setCookie("experiment_" + id, new_variant);
    setExperimentTracker(new_variant, id);
    //console.log("set experiment id")
    return new_variant;
  }
}

export default function data(state = initialState, action = {}) {
  switch (action.type) {
    case types.NOSSR: {
      return {
        ...state,
        ssr: false,
      };
    }

    case types.FETCHEDADDITIONALDATA: {
      let shoe_id = action.value.shoe_id;
      let payload = action.value.payload;
      let index = state.data.findIndex((x) => x.shoe_id === shoe_id);
      let newData = produce(state.data, (draft) => {
        draft[index] = { ...draft[index], ...payload };
      });
      return {
        ...state,
        data: newData,
        //output_data:Helper.filterData(newData,state.filters),
      };
    }

    case types.EXPERIMENT:
      return {
        ...state,
        experimentVersion: state.experimentVersion
          ? state.experimentVersion
          : getExperimentVersion(action.value),
      };
    /*
    case types.NEWSHOE:
      return {
        ...state,
        shoe:newShoe(state.data,action.value)
      };
      */
    case types.FILTERING:
      return {
        ...state,
        filtering: true,
      };

    case types.EXPAND:
      return {
        ...state,
        expanded: addExpansion(state.expanded, action.value.id),
      };

    /*
    case types.SORT:
      let sortedData=sortData(state,action.value);
      let sortBy=action.value.sortBy;
      let newSortOrder="";
      if(action.value.hasOwnProperty("order")){
        newSortOrder=action.value.order;
      }
      else{
        newSortOrder=getSortOrder(state,sortBy);
      }
      return {
        ...state,
        pagination:1,
        data:sortedData,
        //output_data:Helper.filterData(sortedData,state.filters),
        sortBy:action.value.sortBy,
        sortOrder:newSortOrder,

      };
      */
    case types.PAGINATION:
      return {
        ...state,
        pagination: action.value,
      };

    case types.SEARCHTEXT:
      return {
        ...state,
        searchText: action.value,
        filtering: false,
      };

    case types.EDITING:
      return {
        ...state,
        filtering: true,
      };

    case types.SWITCH:
      return {
        ...state,
        switchValue: action.value,
      };

    case types.NOTIFICATIONS:
      return {
        ...state,
        notifications: action.value,
      };

    case types.COLLAPSFILTER:
      return {
        ...state,
        filterExpanded: {
          ...state.filterExpanded,
          [action.value.filter]: action.value.state,
        },
      };

    case types.INITIALDATA:
      if (action.value.stats?.count > 400) {
        rollbarInstance.error("Snapshot has more than 400 shoes");
        console.log("sending rollbar error because too many shoes in snapshot");
      }
      return {
        ...state,
        filtering: false,
        loaded: true,
        overview: action.value.overview,
        data: action.value.data,
        stats: action.value.stats,
        filterArray: action.value.filters,
        sortArray: action.value.sortArray,
        userRatingCategories: action.value.filters
          .filter((x) => x.user)
          .map((x) => x.data),
        expanded: getExpandArray(action.value.data),
        ssr: true,
        filterExpanded: {
          ...action.value.filters.reduce(
            (a, b) => ({ ...a, ...{ [b.data]: true } }),
            {}
          ),
          brand: false,
          player: false,
          availability: false,
        },
      };
    case types.COLLAPSALLFILTER: {
      return {
        ...state,
        filterExpanded: {
          ...state.filterArray.reduce(
            (a, b) => ({ ...a, ...{ [b.data]: true } }),
            {}
          ),
          brand: false,
          player: false,
          availability: false,
        },
      };
    }
    case types.UPDATEDATA:
      return {
        ...state,
        filtering: false,
        loaded: true,
        data: action.value.data,
        stats: action.value.stats,
        filterArray: action.value.filters,
      };

    case types.UPDATELIKECOUNTER: {
      let newCurrentShoe = produce(state.currentShoe, (draftShoe) => {
        if (state.currentShoe?.shoe_id === action.value.shoe_id) {
          let tempStyle = draftShoe?.styles?.filter(
            (style) => style.style_id === action.value.style_id
          )[0];
          if (tempStyle) {
            tempStyle.likes = Math.max(
              0,
              Number(tempStyle.likes) + action.value.addition
            );
          }
        }
      });

      let newData = produce(state.data, (draftData) => {
        let tempShoe = draftData.filter(
          (shoe) => shoe.shoe_id === action.value.shoe_id
        )[0];
        let tempStyle = tempShoe?.styles?.filter(
          (style) => style.style_id === action.value.style_id
        )[0];
        if (tempStyle) {
          tempStyle.likes = Math.max(
            0,
            Number(tempStyle.likes) + action.value.addition
          );
        }
      });
      return {
        ...state,
        data: newData,
        currentShoe: newCurrentShoe,
        //output_data:Helper.filterData(newData,state.filters,state.search),
      };
    }

    case types.SHOEDATA:
      let newData = produce(state.data, (draftData) => {
        let index = draftData.findIndex(
          (shoe) => shoe.shoe_id === action.value?.shoe_id
        );
        if (index !== -1) {
          draftData[index] = action.value;
        }
      });
      return {
        ...state,
        currentShoe: action.value,
        data: newData,
      };

    case types.ABORTFUNCTION:
      return {
        ...state,
        abortFunction: action.value,
      };
    case types.FILTEROBJECT:
      return {
        ...state,
        filterObject: action.value,
      };
    case types.URLMAPPING:
      return {
        ...state,
        urlMapping: action.value,
      };
    case types.MENU:
      return {
        ...state,
        menu: action.value,
      };
    case types.VISITEDQUIZ:
      return {
        ...state,
        visitedQuiz: true,
      };

    default:
      return state;
  }
}
